import lottie from 'lottie-web'

export default {
  
  name: 'lottie-player',

  props: {
    loop: { type: Boolean, default: true },
    autoplay: { type: Boolean, default: true },
    path: { type: String },
    animationData: { type: Object },
  },

  data() {
    return {
      _lottieInstance: null,
    }
  },

  mounted() {
    this._rebuild()
  },

  watch: {
    animationData: '_rebuild',
    path: '_rebuild',
  },

  render(createElement) {
    return createElement('section', this)
  },

  methods: {

    _rebuild() {
      this.destroy()
      this._createAnimation()
    },

    _createAnimation() {
      this._lottieInstance = lottie.loadAnimation({
        container: this.$el,
        renderer: 'svg',
        loop: this.loop,
        autoplay: this.autoplay,
        path: this.path,
        animationData: this.animationData,
      })
    },

    play() {
      this._lottieInstance.play()
    },
    
    stop() {
      this._lottieInstance.stop()
    },
    
    destroy() {
      this._lottieInstance && this._lottieInstance.destroy()
    },
  },

  beforeDestroy() {
    this.destroy()
  },
}